var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3289_48419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 14,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 2H14.3333V14.9993H1.33398V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3289_48419)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20395 9.87835L9.64195 13.8337C9.74861 14.007 9.91528 14.005 9.98261 13.9957C10.0499 13.9864 10.2119 13.945 10.2706 13.7484L13.3193 3.45168C13.3726 3.26968 13.2746 3.14568 13.2306 3.10168C13.1879 3.05769 13.0659 2.96368 12.8893 3.01368L2.58528 6.03102C2.38995 6.08835 2.34728 6.25235 2.33795 6.31968C2.32861 6.38835 2.32595 6.55835 2.49861 6.66702L6.49928 9.16902L10.0339 5.59702C10.2279 5.40102 10.5446 5.39902 10.7413 5.59302C10.9379 5.78702 10.9393 6.10435 10.7453 6.30035L7.20395 9.87835ZM9.93061 14.9997C9.46661 14.9997 9.04128 14.7637 8.79061 14.3584L6.20595 10.1644L1.96861 7.51435C1.51195 7.22835 1.27328 6.71902 1.34728 6.18369C1.42061 5.64835 1.78795 5.22302 2.30395 5.07168L12.6079 2.05435C13.0819 1.91568 13.5899 2.04702 13.9393 2.39502C14.2886 2.74635 14.4186 3.25969 14.2773 3.73569L11.2286 14.0317C11.0759 14.5497 10.6493 14.9157 10.1153 14.987C10.0526 14.995 9.99195 14.9997 9.93061 14.9997Z",
    fill: "#ED9645"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.ae380233dd6937420c3b4805d5b297b7.svg";
export { ForwardRef as ReactComponent };